export default __webpack_public_path__ + "static/media/Id-sana-sini-at-pullman-jakarta-indonesia.755ed381.jpg";